export const SET_NAVBAR_CONVERSATIONS = 'SET_NAVBAR_CONVERSATIONS'
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS'
export const SET_CONVERSATIONS_DETAILS = 'SET_CONVERSATIONS_DETAILS'
export const SET_MESSAGES = 'SET_MESSAGES'
export const INCREASE_LIMIT = 'INCREASE_LIMIT'
export const SET_TOTAL_MESSAGES = 'SET_TOTAL_MESSAGES'
export const SET_EDITED_MESSAGES = 'SET_EDITED_MESSAGES'
export const RESET_CHAT = 'RESET_CHAT'
export const SET_CURRENT_ITEMS = 'SET_CURRENT_ITEMS'
export const SET_CURRENT_TOGGLE_ITEM_FUNCTION =
  'SET_CURRENT_TOGGLE_ITEM_FUNCTION'
export const SET_ASSIGN_SEARCH_VALUE = 'SET_ASSIGN_SEARCH_VALUE'
export const SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION =
  'SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION =
  'SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_SHOW_SELECTED_ITEMS = 'SET_CURRENT_SHOW_SELECTED_ITEMS'
export const RESET_SELECTED_ITEMS = 'RESET_SELECTED_ITEMS'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'
export const SET_CURRENT_SELECTED_ITEMS = 'SET_CURRENT_SELECTED_ITEMS'
export const SET_SHOW_SELECTED_ORG_GROUPS = 'SET_SHOW_SELECTED_ORG_GROUPS'
export const SET_SHOW_SELECTED_USERS = 'SET_SHOW_SELECTED_USERS'
export const SET_SHOW_SELECTED_LOCATION_GROUPS =
  'SET_SHOW_SELECTED_LOCATION_GROUPS'
export const SET_SHOW_SELECTED_STORES = 'SET_SHOW_SELECTED_STORES'
export const SET_SHOW_SELECTED_ROLES = 'SET_SHOW_SELECTED_ROLES'
export const SET_SELECTED_ORG_GROUPS = 'SET_SELECTED_ORG_GROUPS'
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS'
export const SET_SELECTED_LOCATION_GROUPS = 'SET_SELECTED_LOCATION_GROUPS'
export const SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS'
export const SET_SELECTED_ROLES = 'SET_SELECTED_ROLES'
export const SET_SELECTED_STORES = 'SET_SELECTED_STORES'
export const SET_SHOW_SELECTED_LOCATIONS = 'SET_SHOW_SELECTED_LOCATIONS'
export const SET_SELECTED_ROLES_FILTER = 'SET_SELECTED_ROLES_FILTER'
export const SET_SHOW_SELECTED_USERS_ITEMS = 'SET_SHOW_SELECTED_USERS_ITEMS'

export const SET_ALL_USERS = 'SET_ALL_USERS'
export const SET_CREATING_CONVERSATION_LOADING =
  'SET_CREATING_CONVERSATION_LOADING'
export const SET_LOADING_MORE = 'SET_LOADING_MORE'
export const SET_ARCHIVING_MESSAGES = 'SET_ARCHIVING_MESSAGES'
export const SET_GROUP_MEMBERS = 'SET_GROUP_MEMBERS'
export const SET_LOADING_CONVERSATIONS = "SET_LOADING_CONVERSATIONS"
export const SET_LOADING_MESSAGES = "SET_LOADING_MESSAGES"